import * as React from "react";
const SvgEvent = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 13h-5v5h5v-5ZM16 2v2H8V2H6v2H3.01L3 22h18V4h-3V2h-2Zm3 18H5V9h14v11Z",
  fill: "currentColor"
}));
export default SvgEvent;